import React, { Component } from 'react';
import { Result, Button } from 'antd';

class SuccessPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    goToLogin = () => {
        this.props.history.push("/login")
    }

    render() {
        return (<Result
            status="success"
            title="Successfully Change Users Password!"
            extra={
              <Button key="buy" onClick={this.goToLogin}>Go login</Button>
            }
          />)
    }
}
export default SuccessPage;
